import axios from 'axios';
import { setBaseUrl } from './base';
import store from '@/store';

class HttpRequest {
  constructor(clientUid) {
    // this.baseUrl = baseUrl
    this.clientUid = clientUid;
    this.instance = axios.create({
      // baseURL: '', // url = base url + request url
      withCredentials: true, // send cookies when cross-domain requests
      timeout: 30000 // request timeout
    });
    this.interceptors();
  }
  interceptors() {
    // request拦截器
    this.instance.interceptors.request.use(
      request => {
        request.baseURL = setBaseUrl(request.host);
        request.headers['Content-type'] = 'application/json;charset=UTF-8';
        let token =
          sessionStorage.getItem('access_token') || store.state.token || '';
        request.headers['client-uid'] = this.clientUid;
        // request.headers['client-uid'] = '8c41392a7642d7af0720f62a8646de56';
        // let cryptKey = Cookies.get('crypt-key') || ''
        // request.headers['user-key'] = cryptKey
        if (token && token !== 'undefined') {
          request.headers['user-token'] = token;
        }
        if (request.host == 'ai') {
          request.headers['api-key'] = '42acd628bd44d821e67536ec79cbd96d';
        }
        return request;
      },
      error => {
        return Promise.reject(error);
      }
    );

    // respone拦截器
    this.instance.interceptors.response.use(
      response => {
        // uni.hideLoading()
        if (response.data.code == 200) {
          return response;
        } else {
          return Promise.reject(response);
        }
      },
      error => {
        return Promise.reject(error);
      }
    );
  }

  post(url, params = {}, host = 'default') {
    return this.instance({
      url: url,
      method: 'post',
      data: params,
      host
    });
  }

  /**
   * 获取数据，只支持 params 传参
   * @param {*} url
   * @param {*} params
   * @returns
   */
  get(url, params = {}, host = 'default') {
    return this.instance({
      url: url,
      method: 'get',
      params: params,
      host
    });
  }

  /**
   * 更新数据，同时支持  data 和 params
   * @param {*} url
   * @param {*} params
   * @returns
   */
  put(url, params = {}, host = 'default') {
    return this.instance({
      url: url,
      method: 'put',
      data: params,
      host
    });
  }

  /**
   * 删除数据，只支持 params传参
   * @param {*} url
   * @param {*} params
   * @returns
   */
  delete(url, params = {}, host = 'default') {
    return this.instance({
      url: url,
      method: 'delete',
      params: params,
      host
    });
  }
}

export default HttpRequest;
